import { render, staticRenderFns } from "./create-site.vue?vue&type=template&id=5155898e&"
import script from "./create-site.vue?vue&type=script&lang=js&"
export * from "./create-site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports